import React from "react";

const TABLE_CELL_CLASS = "px-3 py-2.5";
const TABLE_HEAD_CLASS =
  "border-b border-gray-200 bg-gray-50 text-[11px] font-semibold uppercase tracking-wide text-gray-500";

function CommissionsTableSkeleton({ rows = 10, embedded = false, columns = [] }) {
  const skeletonColumns =
    columns.length > 0
      ? columns.map((column) => ({
          label: column.title || "#",
          align: column.key === "actions" ? "right" : "left",
          class:
            column.key === "actions" || column.key === "documents"
              ? "h-[26px] w-[26px] rounded-md"
              : column.key === "history_status_title"
                ? "h-4 w-20 rounded-full"
                : "h-3 w-20",
        }))
      : [
          { label: "Client Name", class: "h-3 w-24", align: "left" },
          { label: "Provider & Course", class: "h-3 w-36", align: "left" },
          { label: "Status", class: "h-4 w-20 rounded-full", align: "left" },
          { label: "Intake", class: "h-3 w-14", align: "left" },
          { label: "Last Updated", class: "h-3 w-16", align: "left" },
          { label: "Actions", class: "h-[26px] w-[26px] rounded-md", align: "right" },
        ];

  const table = (
    <div className="cms-commissions-table-wrap overflow-x-auto">
      <table className="w-full min-w-[760px] text-left text-[13px]">
        <thead className={TABLE_HEAD_CLASS}>
          <tr>
            {skeletonColumns.map((col) => (
              <th
                key={col.label}
                className={`${TABLE_CELL_CLASS} ${col.align === "right" ? "text-right" : ""}`}
              >
                {col.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-100">
          {[...Array(rows)].map((_, rowIndex) => (
            <tr key={`skeleton-row-${rowIndex}`}>
              {skeletonColumns.map((col, colIndex) => (
                <td
                  key={`${col.label}-${rowIndex}`}
                  className={`${TABLE_CELL_CLASS} ${col.align === "right" ? "text-right" : ""}`}
                >
                  <div
                    className={`rounded bg-gradient-to-r from-gray-100 via-gray-200/80 to-gray-100 bg-[length:200%_100%] animate-pulse ${col.class} ${
                      col.align === "right" ? "ml-auto" : ""
                    }`}
                    style={{
                      animationDelay: `${(rowIndex * 0.08 + colIndex * 0.04).toFixed(2)}s`,
                    }}
                  />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

  if (embedded) return table;

  return (
    <div
      className="overflow-hidden rounded-md border border-gray-200 bg-white shadow-sm"
      aria-busy="true"
      aria-label="Loading commissions"
    >
      {table}
    </div>
  );
}

export default CommissionsTableSkeleton;
